var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('van-cell',{attrs:{"title":_vm.item.title}}):_vm._e(),_c('div',{staticClass:"box"},[_c('ImageGroup',{attrs:{"fileList":_vm.item.data}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }